<template>
<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1246_3836)">
<path d="M1 1H33V33H1V1Z" fill="#012169"/>
<path d="M33 1V5L21.125 17L33 28.6875V33H28.8125L16.875 21.25L5.25 33H1V28.75L12.625 17.0625L1 5.625V1H4.875L16.875 12.75L28.5 1H33Z" fill="white"/>
<path d="M12.5 21.25L13.1875 23.375L3.625 33H1V32.8125L12.5 21.25ZM20.25 20.5L23.625 21L33 30.1875V33L20.25 20.5ZM33 1L21 13.25L20.75 10.5L30.125 1H33ZM1 1.0625L13.0625 12.875L9.375 12.375L1 4.0625V1.0625Z" fill="#C8102E"/>
<path d="M12 1V33H22V1H12ZM1 12V22H33V12H1Z" fill="white"/>
<path d="M1 14V20H33V14H1ZM14 1V33H20V1H14Z" fill="#C8102E"/>
</g>
<rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#F0F0F0"/>
<defs>
<clipPath id="clip0_1246_3836">
<rect x="1" y="1" width="32" height="32" rx="16" fill="white"/>
</clipPath>
</defs>
</svg>

</template>